import styled from '@emotion/styled';

export const Img = styled('img')({
  width: 17,
  height: 17,
  backgroundSize: 'cover',
});

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  margin: 'auto',
});
